import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { MedicalLetterDto } from '../../models/medical-letter/medical-letter-dto';

@Injectable()
export class MedicalLetterService extends Service {

    public medicalLettersByEmployee: MedicalLetterDto[];
    public medicalLettersByEmployeeObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.medicalLettersByEmployee = [];
        this.medicalLettersByEmployeeObject = {};
    }

    public getAllByEmployeeId(employeeId: string): Observable<MedicalLetterDto[]> {
        // if (!!this.medicalLettersByEmployee && this.medicalLettersByEmployee.length > 0) {
        //     return Observable.create((observer: Subscriber<any[]>) => {
        //         observer.next(this.medicalLettersByEmployee);
        //         observer.complete();
        //     });
        // }
        const url = 'medicalletters/allByEmployeeId/' + employeeId;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.medicalLettersByEmployee = r.Result;
                console.log(this.medicalLettersByEmployee);
                this.medicalLettersByEmployeeObject = this.medicalLettersByEmployee.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('employeeservice > getAll > response', r);
            }
            return this.medicalLettersByEmployee;
        }).catch(this.handleError);
    }


    public addOrEdit(medicalLetterDto: MedicalLetterDto) {
        const url = 'medicalletters/add';
        return this.http.post(url, medicalLetterDto).map(response => response.json())
            .catch(this.handleError);
    }

    public delete(id: string) {
        const url: string = 'employees/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/medical-letter/medical-letter-service.ts